<template>
    <div class="functionListDiv">
        <div class="functionListTab">
            <WaterFee></WaterFee>
        </div>
        <div class="footerArea">© 2020 马鞍山首创水务有限责任公司 All Rights Reserved</div>
    </div>
</template>

<script>
    import WaterFee from '../WaterFee/WaterFee';
    export default {
        name: "BillPaymentList",//账单缴费list
        components:{
            WaterFee
        },
        data(){
            return {

            }
        },
        methods:{

        }
    }
</script>

<style scoped>
.functionListDiv{height:100%;}
</style>